import axios from "axios";

if (!globalThis.axios) {
  globalThis.axios = axios;
}

export default globalThis.axios;
